import React from 'react'
import Banner from "../components/Banner"
import CoinsTable from '../components/CoinsTable'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <>
      <Banner/>
      <CoinsTable/>
      <Footer/>
    </>
  )
}

export default Home